import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { TenantListPage } from './pages/TenantListPage';
import { CustomerRecordPage } from './pages/CustomerRecordPage';
import { AdminsPage } from './pages/AdminsPage';
import { AuditPage } from './pages/AuditPage';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';

/**
 * Route map — Phase 1.
 *
 *   /login                  Login + MFA challenge
 *   /tenants                Tenant list (UCR search)   [read-only+]
 *   /tenants/:id            Unified Customer Record    [read-only+]
 *   /admins                 Admin account CRUD         [superadmin only]
 *   /audit                  Audit log explorer         [support-lead+ full; csr own actions]
 *
 * Phase 2 additions: /tenants/:id/impersonate, /broadcast
 * Phase 3 additions: /voice (live call dashboard), /metrics, /flags
 */
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/tenants" replace />} />
        <Route path="/tenants" element={<TenantListPage />} />
        <Route path="/tenants/:tenantId" element={<CustomerRecordPage />} />
        <Route
          path="/admins"
          element={
            <ProtectedRoute requireRole="superadmin">
              <AdminsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/audit" element={<AuditPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/tenants" replace />} />
    </Routes>
  );
}
